<template>
    <rkm-area
        v-if="cliente && cliente.ativoAppConectasusCidadao"
        title="Integrações de Aplicativos"
        type="fieldset"
    >
        <rkm-row>
            <rkm-col cols="auto">
                <rkm-form-checkbox v-model="data.model.habilitaVacinacaoConectasusCidadao">
                    Habilitar a funcionalidade Vacinação no App Cidadão
                    <rkm-icon
                        icon="info"
                        color="secondary"
                        class="infor"
                        small
                        v-rkm-popover.hover.left="{
                            html: true,
                            content: 'Quando ativado, permite que o cidadão consulte a carteira de vacinação no App do Cidadão. Quando desativado, a funcionalidade não é exibida no App.'
                        }"
                    />
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: {
        data: { required: true, type: Object },
    },
    computed: {
        ...mapGetters({cliente: 'getCliente'}),
    },
}
</script>

<style scoped>
    .infor {
        color: #acacac;
        height: 15px;
        width: 15px !important;
        border-radius: 31px;
        padding: 3px;
        border: 1px solid #c2c2c2;
        vertical-align: middle;
        margin-left: 4px;
    }
</style>
